<div id = "mapid">
</div>
<div [hidden]="'true'">
  <app-request *ngIf="request" [request]="request" [popupMode]="'true'"></app-request>
</div>
